import dynamic from 'next/dynamic';
import A from './components/A';
// import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import { useGlobal } from '@/utils/useGlobal';
import BlackFriday from '@elem/compCommon/PillarPageActivities/BlackFriday';

const IndexDynamic = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

export default function ProductDetail({ freeQuote, freeQuoteBack }: any) {
    const { useEffect } = useGlobal();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window.AniContainer) {
            return () => AniContainer.destroy();
        }
    }, []);

    return (
        <div className={`dpu-launch-detail GtmModuleData-section`} data-section-id={'dpu-Detail'} data-section-title={'dpu-Detail'}>
            <A />
            <BlackFriday />
            <IndexDynamic freeQuote={freeQuote} freeQuoteBack={freeQuoteBack} />
            <style jsx global>
                {`
                    .footer {
                        background-color: #1f1f1f !important;
                        border-top-color: #343434 !important;
                    }
                    .footer-annotation {
                        background-color: #1f1f1f !important;
                    }
                `}
            </style>
        </div>
    );
}
